import React from 'react';
import Table from '../../../../components/_table/Table';
import { columns } from './columns';
import Panel from '../../../../components/outline/Panel';
import './PointList.scss';

const PointList = (props) => {
  const { pointList, getList, initialOption, pagination, sortOption } = props;

  return (
    <div className="point-list">
      <Panel>
        <div className="panel-body">
          <Table
            columns={(utils) =>
              columns({
                ...utils,
              })
            }
            rowKey={(record) => record.id}
            list={pointList}
            initialOption={initialOption}
            sortOption={sortOption}
            pagination={pagination}
            size="small"
            scroll={{ x: true }}
            bordered={true}
            getList={getList}
          />
        </div>
      </Panel>
    </div>
  );
};

export default PointList;
